import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export default function PendingApproval() {
  const navigate = useNavigate()
  const location = useLocation()
  const [email, setEmail] = useState('')

  useEffect(() => {
    // Get email from location state or session storage
    const stateEmail = location.state?.email
    const sessionEmail = sessionStorage.getItem('pendingApprovalEmail')
    setEmail(stateEmail || sessionEmail || 'your email')
  }, [location])

  return (
    <div className='min-h-screen bg-gray-100 flex items-center justify-center w-full p-6'>
      <div className='w-96 text-center'>
        <div className='mb-6'>
          <div className='inline-block p-3 bg-yellow-100 rounded-full'>
            <svg
              className='w-12 h-12 text-yellow-600'
              fill='currentColor'
              viewBox='0 0 20 20'
            >
              <path
                fillRule='evenodd'
                d='M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z'
                clipRule='evenodd'
              />
            </svg>
          </div>
        </div>

        <h1 className='text-3xl font-bold text-gray-900 mb-4'>承認待ち</h1>

        <div className='bg-blue-50 border border-blue-200 rounded-lg p-6 mb-6'>
          <p className='text-gray-700 mb-4'>
            Googleでのサインアップありがとうございます！アカウントが正常に作成されました。
          </p>
          <p className='text-gray-700 mb-4'>
            <strong>アカウントのメールアドレス:</strong> {email}
          </p>
          <p className='text-gray-700'>
            現在、アカウントは管理者の承認待ちです。管理者がリクエストを確認し、アカウントを有効化します。
          </p>
        </div>

        <div className='bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6'>
          <h3 className='font-semibold text-gray-900 mb-2'>
            次に何が起こりますか？
          </h3>
          <ul className='text-sm text-gray-600 space-y-2 text-left'>
            <li>✓ 管理者がアカウントを確認します</li>
            <li>✓ 承認されるとメール通知が届きます</li>
            <li>✓ その後、Googleアカウントでログインできます</li>
          </ul>
        </div>

        <p className='text-sm text-gray-600 mb-6'>
          ご不明な点がございましたら、管理者にお問い合わせください。
        </p>

        <button
          onClick={() => navigate('/login')}
          className='w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium transition'
        >
          ログイン画面に戻る
        </button>
      </div>
    </div>
  )
}
